// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"543":"799bd7ea","638":"8fe82189"}[chunkId] + ".chunk.css";
};